<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-right>
      <vdr-action-bar-items
        [locationId]="'inbound-list'"
      ></vdr-action-bar-items>
      <div *ngIf="!currentRoute || currentRoute == 'waiting'">
        <button
          class="button primary"
          (click)="inProgress()"
          style="margin-right: 1rem"
          [disabled]="setInProgressDisabled()"
          *vdrIfPermissions="['UpdateInbounding']"
        >
          {{ "requestPurchase.set-in-progress" | translate }}
        </button>
      </div>
      <div
        *ngIf="
          !currentRoute ||
          currentRoute == 'waiting' ||
          currentRoute == 'in-progress'
        "
      >
        <button
          class="button primary"
          (click)="complete()"
          style="margin-right: 1rem"
          [disabled]="completeDisabled()"
          *vdrIfPermissions="['UpdateInbounding']"
        >
          {{ "common.complete" | translate }}
        </button>
      </div>
      <div *ngIf="!currentRoute || currentRoute == 'complete'">
        <button
          class="button primary"
          (click)="confirm()"
          style="margin-right: 1rem"
          [disabled]="confirmDisabled()"
          *vdrIfPermissions="['UpdateInbounding']"
        >
          {{ "common.confirm" | translate }}
        </button>
      </div>
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>

<vdr-split-view
  [rightPanelOpen]="activeInboundingId$ | async"
  (closeClicked)="closeContents()"
>
  <ng-template vdrSplitViewLeft>
    <custom-data-table
      class="mt-2"
      id="inbounding-table"
      [items]="items$ | async"
      [itemsPerPage]="itemsPerPage$ | async"
      [totalItems]="totalItems$ | async"
      [currentPage]="currentPage$ | async"
      [filters]="filters"
      [expandedRowIndex]="expandedRowIndex"
      (pageChange)="setPageNumber($event)"
      (itemsPerPageChange)="setItemsPerPage($event)"
    >
      <vdr-bulk-action-menu
        locationId="inbounding-page"
        [hostComponent]="this"
        [selectionManager]="selectionManager"
      ></vdr-bulk-action-menu>
      <vdr-dt2-search
        [searchTermControl]="searchTermControl"
        [searchTermPlaceholder]="'Search Inbounding By Name'"
      />

      <expand-div>
        <ng-template let-item="item" let-index="index">
          <inbound-expand-content [item]="item" [index]="index" />
        </ng-template>
      </expand-div>

      <vdr-dt2-column
        [heading]="'common.id' | translate"
        id="id"
        [hiddenByDefault]="true"
        [sort]="sorts.get('id')"
      >
        <ng-template let-inbounding="item">
          <a class="button-ghost" [routerLink]="['./', inbounding.id]">
            <span>
              {{ inbounding.id }}
            </span>
            <clr-icon shape="arrow right" />
          </a>
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'requestPurchase.identifier' | translate"
        id="id"
        [hiddenByDefault]="false"
      >
        <ng-template let-inbounding="item">
          {{ inbounding.group.identifier }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'common.productName' | translate"
        id="id"
        [hiddenByDefault]="false"
      >
        <ng-template let-inbounding="item">
          <a
            class="button-ghost"
            [routerLink]="['/catalog/products', inbounding.group.productId]"
          >
            <span>
              {{ inbounding.group.product.name }}
            </span>
            <clr-icon shape="arrow right" />
          </a>
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'common.details' | translate"
        id="view-contents"
        [hiddenByDefault]="false"
      >
        <ng-template let-inbounding="item" let-i="index">
          <!-- <a
            class="button-small bg-weight-150"
            [routerLink]="['./', { contents: inbounding.id }]"
            queryParamsHandling="merge"
          >
            <span>{{ "common.view-contents" | translate }}</span>
            <clr-icon shape="file-group"></clr-icon>
          </a> -->

          <button class="button-ghost" (click)="setRowExpand(i)">
            <span>{{ "common.view-contents" | translate }}</span>
            <clr-icon shape="file-group"></clr-icon>
          </button>
        </ng-template>
      </vdr-dt2-column>

      <!--       <vdr-dt2-column
        [heading]="'Expected date'"
        id="expected-date"
        [hiddenByDefault]="false"
      >
        <ng-template let-inbounding="item">
          <span *ngIf="inbounding.group.expectedDate; else noDate">
            {{ inbounding.group.expectedDate | localeDate : "short" }}
          </span>
          <ng-template #noDate>*</ng-template>
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'inbounding.remainingDays' | translate"
        id="daysLate"
        [hiddenByDefault]="false"
      >
        <ng-template let-inbounding="item">
          {{ inbounding.daysLate }}
        </ng-template>
      </vdr-dt2-column> -->

      <vdr-dt2-column
        [heading]="'common.status' | translate"
        id="status"
        [hiddenByDefault]="false"
        [sort]="sorts.get('status')"
      >
        <ng-template let-inbounding="item">
          {{ inbounding.status }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'common.created-at' | translate"
        id="created-at"
        [hiddenByDefault]="false"
        [sort]="sorts.get('createdAt')"
      >
        <ng-template let-inbounding="item">
          {{ inbounding.createdAt | localeDate : "short" }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'common.updated-at' | translate"
        id="updated-at"
        [hiddenByDefault]="false"
        [sort]="sorts.get('updatedAt')"
      >
        <ng-template let-inbounding="item">
          {{ inbounding.updatedAt | localeDate : "short" }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'requestPurchase.currentStock' | translate"
        id="totalStockOnHand"
        [hiddenByDefault]="true"
      >
        <ng-template let-inbounding="item">
          {{ inbounding.totalStockOnHand }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'requestPurchase.orderQuantity' | translate"
        id="totalOrderQuantity"
        [hiddenByDefault]="true"
      >
        <ng-template let-inbounding="item">
          {{ inbounding.totalOrderQuantity }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'requestPurchase.total-quantity-needed' | translate"
        id="totalStockOnHand"
        [hiddenByDefault]="true"
      >
        <ng-template let-inbounding="item">
          {{ inbounding.totalQuantityNeeded }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'requestPurchase.total-quantity-fulfilled' | translate"
        id="totalStockOnHand"
        [hiddenByDefault]="true"
      >
        <ng-template let-inbounding="item">
          {{ inbounding.totalQuantityFulfilled }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'requestPurchase.detail' | translate"
        id="id"
        [hiddenByDefault]="false"
      >
        <ng-template let-inbounding="item">
          <a class="button-ghost" [routerLink]="['./', inbounding.id]">
            <span> {{ "requestPurchase.detail" | translate }}</span
            ><clr-icon shape="arrow right"></clr-icon>
          </a>
        </ng-template>
      </vdr-dt2-column>
    </custom-data-table>
  </ng-template>
  <ng-template vdrSplitViewRight [splitViewTitle]="'  '">
    <inbound-extend-view [inboundId]="activeInboundingId$ | async" />
  </ng-template>
</vdr-split-view>
